import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";

import { MAX_NUMBER_TO_CUT_POSITION } from "app/components/RankingAxis/constants";
import { RankingAxisWrapper } from "app/components/RankingAxis/styles";
import { CenteredFlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, blue } = colorsPalettes;

export const SearchOverviewPpcSpendWrapper = styled.div`
    width: 100%;
`;

export const RankingContainer = styled(FlexColumn)<{ height?: string }>`
    padding: 16px 24px 0px 24px;
    min-height: 164px;
    justify-content: space-evenly;
    align-items: center;
    height: ${({ height }) => (height ? height : "100%")};
    box-sizing: border-box;
`;

export const RowWrapper = styled(CenteredFlexRow)`
    width: 100%;
    gap: 16px;
    height: 48px;
`;

export const Title = styled.div`
    ${setFontVariant("listItem3", carbon[300])};
    width: 80px;
    min-width: 80px;
    text-align: left;
`;

export const StyledRankingAxisWrapper = styled(RankingAxisWrapper)`
    width: 100%;
    padding-left: 0px;
    margin-top: -16px;
`;

export const AxisDot = styled(CenteredFlexRow)<{
    position: number;
}>`
    position: absolute;

    overflow: hidden;
    z-index: 1;
    box-sizing: border-box;

    border-radius: 6px;
    background: ${carbon[0]};

    .ItemIcon {
        width: 24px;
        height: 24px;
        overflow: hidden;
    }

    left: ${({ position }) => (position > MAX_NUMBER_TO_CUT_POSITION ? `calc(${position}% - 16px)` : `${position}%`)};

    &:hover {
        z-index: 2;
        height: 24px;
        width: 24px;
        border: 2px solid ${blue[400]};
    }
`;

export const StyledItemIcon = styled(ItemIcon)`
    border-color: ${carbon[100]};
    width: 24px;
    height: 24px;

    img {
        width: 16px;
        height: 16px;
    }
`;
